import * as React from "react"
import "./src/styles/global.css"
import MinistryRouteGuard from "./src/components/ministry/MinistryRouteGuard"

export const wrapPageElement = ({ element, props }) => (
  <MinistryRouteGuard location={props.location}>{element}</MinistryRouteGuard>
)
